<mat-expansion-panel [expanded]="autoExpand">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'orderStatusTypeIDs'" [placeholder]="'common.labels.orderStatus' | transloco" multiple="true">
          @for (option of _orderStatusTypeOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-container">
      <div class="flex-item">
        <mat-checkbox formControlName="isStaged">
          {{ 'common.labels.staged' | transloco }}
        </mat-checkbox>
      </div>
      <div class="flex-item">
        <mat-checkbox formControlName="isSubmitted">
          {{ 'common.labels.submitted' | transloco }}
        </mat-checkbox>
      </div>
      <div class="flex-item">
        <mat-checkbox formControlName="hasRequestErrors">
          {{ 'common.labels.hasRequestErrorS' | transloco }}
        </mat-checkbox>
      </div>
      <div class="flex-item">
        <mat-checkbox formControlName="hasRequestWarnings">
          {{ 'common.labels.hasRequestWarningS' | transloco }}
        </mat-checkbox>
      </div>
    </div>

    <div class="spacer-small"></div>

    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>